"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FlagES = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: '1em', viewBox: '0 0 24 24', width: '1em', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react_1.default.createElement("title", null, "Flag of Spain"),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: 'prefix__a', d: 'M0 13.996h20V0H0z' })),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("g", { transform: 'translate(2 5)' },
                react_1.default.createElement("path", { fill: '#FFF423', d: 'M0 10.396h20V3.593H0z' }),
                react_1.default.createElement("path", { d: 'M0 12.996c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-2.602H0v2.602zM19 0H1C.45 0 0 .45 0 1v2.599h20V1c0-.55-.45-1-1-1M3.364 6.242c-.112-.046-.153-.136-.112-.228.041-.094.222-.119.345-.094.124-.027.305 0 .347.094.04.092 0 .182-.113.228a1.123 1.123 0 00-.467 0', fill: '#E91C35' })),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = FlagES;
